// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__36_u0","footer":"ModalUpdate_footer__3JAd7"};